import Vue from 'vue';
import VueTelInput from 'vue-tel-input';
import VueCookies from 'vue-cookies';
import moment from 'moment';
import VueMoment from 'vue-moment';
import VueMask from 'v-mask';
import VueI18n from 'vue-i18n';
import { VueReCaptcha } from 'vue-recaptcha-v3';

import { InputDialog, Dialog, Alert } from 'components@/dialog';
import Card from 'components@/card';

import ServicesMenu from 'components@/_services-menu';
import Filters from 'common@/filters';

import Button from 'global-components/button';
import DropButton from 'global-components/button-drop';
import Spacer from 'global-components/spacer';
import Loading from 'global-components/loading';
import CardForm from 'global-components/card-form';

import axios from './api';
import ICHelper from './api/interceptor';
import App from './App.vue';
import router from './router';
import store from './store';

import './assets/main.scss';

import ru from './locales/ru';
import en from './locales/en';
import be from './locales/be';
import ge from './locales/ge';
import az from './locales/az';

ICHelper();

Vue.use(Spacer);
Vue.use(Button);
Vue.use(DropButton);

Vue.use(InputDialog);
Vue.use(Dialog);
Vue.use(Alert);

Vue.use(Card);
Vue.use(ServicesMenu);

Vue.use(axios);
Vue.use(VueTelInput);
Vue.use(VueCookies);
Vue.use(VueMask);
Vue.use(VueI18n);
Vue.use(Filters);
Vue.use(Loading, {
  name: 'IsLoading',
});
Vue.use(CardForm, {
  name: 'BePaidForm',
});

Vue.use(VueMoment, {
  moment,
});

Vue.use(VueReCaptcha, {
  siteKey: '6LcYl18lAAAAAFpYO5q9j1XisaBCafdnR47W0pLA',
  loaderOptions: {
    useRecaptchaNet: true,
  },
});

Vue.prototype.$axios = axios;
Vue.config.productionTip = false;


new Vue({
  router,
  store,
  axios,
  i18n: new VueI18n({
    locale: 'ru',
    messages: {
      ru,
      en,
      be,
      ge,
      az,
    },
  }),
  render: (h) => h(App),
  methods: {
    login() {
    },
    logout() {
      if (Object.prototype.hasOwnProperty.call(this.$root, 'wizard') && this.$root.wizard) {
        this.$root.wizard.logout();
      }

      this.$cookies.remove('avatar', '/', '.24afisha.by');
      this.$cookies.remove('token', '/', '.24afisha.by');
      this.$cookies.remove('username', '/', '.24afisha.by');

      this.$cookies.remove('avatar', '/', '.guru.ge');
      this.$cookies.remove('token', '/', '.guru.ge');
      this.$cookies.remove('username', '/', '.guru.ge');

      this.$cookies.remove('avatar', '/', '.localhost');
      this.$cookies.remove('token', '/', '.localhost');
      this.$cookies.remove('username', '/', '.localhost');

      this.$store.commit('logout');
      this.$axios.defaults.headers.Authorization = '';

      if (window.location && window.location.host.includes('guru.ge')) {
        window.location.href = 'https://guru.ge';
      } else {
        window.location.reload();
      }
    },
  },
}).$mount('#app');
